import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// FullCalendar v6+ injects its own styles automatically via JS (no external CSS needed).
import './index.css';

// Silence all frontend console output in production by default (security + UX).
// Set REACT_APP_ENABLE_FRONTEND_LOGS=true at build time to re-enable for troubleshooting.
if (
  process.env.NODE_ENV === 'production' &&
  String(process.env.REACT_APP_ENABLE_FRONTEND_LOGS || '').toLowerCase() !== 'true'
) {
  // eslint-disable-next-line no-console
  console.log = () => {};
  // eslint-disable-next-line no-console
  console.debug = () => {};
  // eslint-disable-next-line no-console
  console.info = () => {};
  // eslint-disable-next-line no-console
  console.warn = () => {};
  // eslint-disable-next-line no-console
  console.error = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
